export default function FeedResource(module) {
    angular.module(module || 'app')
        .factory('searchResource', searchResource);

    /**
     * @ngdoc function
     * @name feedResource
     * @description
     * Collection of api routes used for feeds.
     * @requires $resourcesearchResource
     * */
    searchResource.$inject = ['$http'];
    function searchResource($http) {
        return {
            list: function (params) {
                return $http.get('/api/search/', {
                    params: params
                });
            }
        };
    }
};